var map = {
	"./1.png": "./src/assets/testTri/1.png",
	"./10.png": "./src/assets/testTri/10.png",
	"./11.png": "./src/assets/testTri/11.png",
	"./12.png": "./src/assets/testTri/12.png",
	"./13.png": "./src/assets/testTri/13.png",
	"./14.png": "./src/assets/testTri/14.png",
	"./15.png": "./src/assets/testTri/15.png",
	"./16.png": "./src/assets/testTri/16.png",
	"./17.png": "./src/assets/testTri/17.png",
	"./18.png": "./src/assets/testTri/18.png",
	"./19.png": "./src/assets/testTri/19.png",
	"./2.png": "./src/assets/testTri/2.png",
	"./20.png": "./src/assets/testTri/20.png",
	"./21.png": "./src/assets/testTri/21.png",
	"./22.png": "./src/assets/testTri/22.png",
	"./23.png": "./src/assets/testTri/23.png",
	"./24.png": "./src/assets/testTri/24.png",
	"./25.png": "./src/assets/testTri/25.png",
	"./26.png": "./src/assets/testTri/26.png",
	"./27.png": "./src/assets/testTri/27.png",
	"./28.png": "./src/assets/testTri/28.png",
	"./29.png": "./src/assets/testTri/29.png",
	"./3.png": "./src/assets/testTri/3.png",
	"./30.png": "./src/assets/testTri/30.png",
	"./4.png": "./src/assets/testTri/4.png",
	"./5.png": "./src/assets/testTri/5.png",
	"./6.png": "./src/assets/testTri/6.png",
	"./7.png": "./src/assets/testTri/7.png",
	"./8.png": "./src/assets/testTri/8.png",
	"./9.png": "./src/assets/testTri/9.png",
	"./vezba1.png": "./src/assets/testTri/vezba1.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/testTri sync recursive ^\\.\\/.*\\.png$";